import clsx from "clsx";
import React, { useState } from "react";
import LoadingSpinnerInline from "../../../../components/common/loading-spinner/loading-spinner-inline";

type MenuInput = {
  id: number;
  name: string;
  price: number;
  img: File | null; // 파일로 수정
  description: string;
};

type AddMenuModalProps = {
  onClose: () => void;
  onSave: (menu: MenuInput) => Promise<void>;
};

const AddMenuModal: React.FC<AddMenuModalProps> = ({ onClose, onSave }) => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState<number | "">("");
  const [img, setImg] = useState<File | null>(null); // 파일 타입으로 수정
  const [description, setDescription] = useState("");
  const [buttonBlockStyle, setButtonBlockStyle] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImg(file);
    }
  };

  const handleClick = async () => {
    if (!name || !price || !img) {
      alert("이름, 가격, 이미지는 입력해 주세요.");
      return;
    }

    setButtonBlockStyle("pointer-events-none opacity-80");
    setIsLoading(true);

    const newMenu: MenuInput = {
      id: Math.random(), // 고유한 ID 생성, 실제로는 서버에서 생성된 ID 사용
      name,
      price: Number(price),
      img, // 파일로 전달
      description,
    };

    await onSave(newMenu);
    setIsLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg w-80">
        <h2 className="text-3xl font-semibold mb-4">메뉴 추가</h2>

        <div className="mb-4">
          <label className="block text-2xl font-medium text-gray-700">
            이름
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            placeholder="메뉴 이름 입력"
          />
        </div>

        <div className="mb-4">
          <label className="block text-2xl font-medium text-gray-700">
            가격
          </label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(Number(e.target.value))}
            className="w-full border px-3 py-2 rounded"
            placeholder="가격 입력"
          />
        </div>

        <div className="mb-4">
          <label className="block text-2xl font-medium text-gray-700">
            이미지 업로드
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block text-2xl font-medium text-gray-700">
            설명 (선택)
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            placeholder="메뉴 설명을 입력하세요"
            rows={3}
          />
        </div>

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="text-2xl px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            취소
          </button>
          <button
            onClick={handleClick}
            className={clsx(
              "text-2xl inline-flex items-center justify-center px-4 py-2 min-w-16",
              "bg-[#1562fc] text-white rounded-md active:bg-[#124ab7] transition duration-150",
              buttonBlockStyle
            )}
            disabled={isLoading}
          >
            {isLoading ? <LoadingSpinnerInline /> : "저장"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMenuModal;
